<div class="dialog-container">

  <!-- Seção fixa: alert de diferença -->
  <div class="dialog-fixed">

    <!-- Alert de diferença -->
    @if (Math.abs(diferenca) >= 0.01) {
    <app-alert-card type="warning" [title]="'Corrija a diferença de ' + (diferenca | abnt:'preco')" [closable]="false"
      class="mb-3">
      O valor está diferente do extrato do banco. Ajuste os lançamentos abaixo.
    </app-alert-card>
    } @else {
    <app-alert-card type="success" title="Valores conferem!" [closable]="false" class="mb-3">
      A soma dos lançamentos ajustados é igual ao valor do extrato.
    </app-alert-card>
    }

  </div><!-- /dialog-fixed -->

  <!-- Seção scrollável: cards de itens -->
  <div class="dialog-body">

    <!-- Cards de itens -->
    @for (item of itensSelecionados; track item.tipoMatch + '_' + item.idRegistro; let i = $index) {
    <div class="item-card mb-2" [formGroup]="formAt(i)">

      <!-- Topo: tipo + data + valor aberto -->
      <div class="item-top">
        <div class="item-top-left">
          <span class="status-badge badge-cinza">{{ tipoLabel(item) }}</span>
          <span class="item-data">{{ item.dataReferencia | date:'dd/MM/yyyy' }}</span>
        </div>
        <div class="item-valor-aberto">
          <span class="enc-label">Vlr. Aberto</span>
          <span class="enc-value">{{ item.valorEmAberto | abnt:'preco' }}</span>
        </div>
      </div>

      <!-- Informações principais -->
      <div class="item-main-info">
        <div class="item-descricao">{{ item.descricao }}</div>
        @if (item.nomeEntidade) {
        <div class="item-entidade">{{ item.nomeEntidade }}</div>
        }
      </div>

      <!-- Campos de ajuste -->
      @if (temEncargos(item)) {
      <div class="encargos-grid">
        <mat-form-field appearance="outline" subscriptSizing="dynamic" class="enc-form-field">
          <mat-label>Juros</mat-label>
          <input matInput [currencyMask]="currencyMask" formControlName="valorJuros">
        </mat-form-field>
        <mat-form-field appearance="outline" subscriptSizing="dynamic" class="enc-form-field">
          <mat-label>Multa</mat-label>
          <input matInput [currencyMask]="currencyMask" formControlName="valorMulta">
        </mat-form-field>
        <mat-form-field appearance="outline" subscriptSizing="dynamic" class="enc-form-field">
          <mat-label>Desconto</mat-label>
          <input matInput [currencyMask]="currencyMask" formControlName="valorDesconto">
        </mat-form-field>
        <mat-form-field appearance="outline" subscriptSizing="dynamic" class="enc-form-field">
          <mat-label>Taxa</mat-label>
          <input matInput [currencyMask]="currencyMask" formControlName="valorTaxa">
        </mat-form-field>
        @if (temBaixaParcial(item)) {
        <mat-form-field appearance="outline" subscriptSizing="dynamic" class="enc-form-field">
          <mat-label>Valor para baixa parcial</mat-label>
          <input matInput [currencyMask]="currencyMask" formControlName="valorPrincipalPago">
        </mat-form-field>
        }
      </div>
      } @else {
      <div class="encargos-grid">
        <mat-form-field appearance="outline" subscriptSizing="dynamic" class="enc-form-field enc-form-field--valor">
          <mat-label>Novo Valor</mat-label>
          <input matInput [currencyMask]="currencyMask" formControlName="novoValor">
        </mat-form-field>
      </div>
      }

      <!-- Valor final -->
      <div class="item-footer">
        <span class="enc-label">Valor final</span>
        <span class="valor-final fw-bold">{{ valorFinalItem(i) | abnt:'preco' }}</span>
      </div>

    </div>
    }

  </div>

</div>